import React, { useState } from 'react';
import {
  MDBIcon,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
  MDBRow
} from 'mdb-react-ui-kit';

export default function Footer_N_M_V() {
  const [iconsActive, setIconsActive] = useState('pill1');

  const handleIconsClick = (value) => {
    if (value === iconsActive) {
      return;
    }

    setIconsActive(value);
  };

  return (
    <>
      <MDBRow>
        <MDBTabs pills className='mb-1'>
          <MDBTabsItem>
            <MDBTabsLink onClick={() => handleIconsClick('pill1')} active={iconsActive === 'pill1'}>
              <MDBIcon fas icon='shapes' className='me-2' /> Descripcion
            </MDBTabsLink>
          </MDBTabsItem>
          <MDBTabsItem>
            <MDBTabsLink onClick={() => handleIconsClick('pill2')} active={iconsActive === 'pill2'}>
              <MDBIcon fas icon='bullseye' className='me-2' /> Mision
            </MDBTabsLink>
          </MDBTabsItem>
          <MDBTabsItem>
            <MDBTabsLink onClick={() => handleIconsClick('pill3')} active={iconsActive === 'pill3'}>
              <MDBIcon fas icon='eye' className='me-2' /> Vision
            </MDBTabsLink>
          </MDBTabsItem>          
          <MDBTabsItem>
            <MDBTabsLink onClick={() => handleIconsClick('pill4')} active={iconsActive === 'pill4'}>
              <MDBIcon fas icon='thumbtack' className='me-2' /> Objetivo
            </MDBTabsLink>
          </MDBTabsItem>
        </MDBTabs>
      </MDBRow>
      <MDBTabsContent>
        <MDBTabsPane open={iconsActive === 'pill1'}>
          <h6 className='text-uppercase fw-bold mb-4'>
            <MDBIcon color='secondary' icon='shapes' className='me-3' />
            Descripcion
          </h6>
          <p>
            Donuts Paradise ofrece una experiencia culinaria única con donas y mini donas artesanales. Con una amplia variedad de ingredientes frescos, 
            invitamos a los clientes a personalizar sus donas favoritas. Nuestro equipo de pasteleros expertos utiliza ingredientes de alta calidad para crear 
            donas irresistibles. En un ambiente acogedor, te invitamos a disfrutar de momentos especiales mientras exploras combinaciones infinitas de sabores. 
            En Donuts Paradise, aspiramos a superar tus expectativas y convertir cada visita en una experiencia memorable. Únete a nosotros y descubre el auténtico paraíso de las donas.          
            </p>
            </MDBTabsPane>
        <MDBTabsPane open={iconsActive === 'pill2'}>
          <h6 className='text-uppercase fw-bold mb-4'>
            <MDBIcon color='secondary' icon='bullseye' className='me-3' />
            Misión:
          </h6>
          <p>
            En Donuts Paradise, nos comprometemos a crear una experiencia de completa satisfacción para nuestros clientes, 
            combinando la más alta calidad en nuestros productos con precios accesibles. Buscamos ser el destino preferido de los amantes de las donas, 
            donde la excelencia culinaria y la accesibilidad se encuentran para brindar momentos dulces e inolvidables a todos nuestros clientes.          
            </p>
            </MDBTabsPane>
            <MDBTabsPane open={iconsActive === 'pill3'}>
          <h6 className='text-uppercase fw-bold mb-4'>
            <MDBIcon color='secondary' icon='eye' className='me-3' />
            Visión
          </h6>
          <p>
          Aspiramos a ser líderes en el universo de las donas, manteniendo un crecimiento constante y mejorando continuamente la calidad y el servicio que ofrecemos. 
          Nos proyectamos expandiendo nuestro horizonte en el fascinante mundo de los sabores y la repostería, siendo reconocidos como un negocio cautivador que despierta los 
          sentidos y crea experiencias memorables para nuestros clientes. 
          En Donuts Paradise, visualizamos un futuro donde nuestra pasión por la excelencia nos consolide como referentes en el arte de deleitar con donas extraordinarias.
          </p>
        </MDBTabsPane>        
        <MDBTabsPane open={iconsActive === 'pill4'}>
          <h6 className='text-uppercase fw-bold mb-4'>
            <MDBIcon color='secondary' icon='thumbtack' className='me-3' />
            Objetivo
          </h6>
          <p>
          Nuestra meta primordial es ofrecer el mejor producto, destacándonos tanto en términos de calidad como de accesibilidad. 
          Buscamos no solo superar las expectativas de nuestros clientes en cuanto a sabor y frescura, sino también asegurarnos de que nuestras delicias estén al alcance de todos, 
          consolidando así nuestra posición como la elección predilecta para quienes buscan la combinación perfecta entre excelencia y accesibilidad en cada bocado.
          </p>
        </MDBTabsPane>
      </MDBTabsContent>
    </>
  );
}